import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const serviceLinks = [
    { label: 'Estrategia Digital', href: '/servicios' },
    { label: 'Identidad Visual', href: '/servicios' },
    { label: 'Diseño Web', href: '/servicios' },
    { label: 'Redes Sociales', href: '/servicios' },
    { label: 'Publicidad Digital', href: '/servicios' },
    { label: 'SEO & Analítica', href: '/servicios' },
    { label: 'Creación de Agentes IA', href: '/servicios' },
    { label: 'Software a Medida', href: '/servicios' },
  ];

  const companyLinks = [
    { label: 'Nosotros', href: '/nosotros' },
    { label: 'Operturi', href: '/operturi' },
    { label: 'Plataformas', href: '/plataformas' },
    { label: 'FAQs', href: '/faqs' },
    { label: 'Contacto', href: '/contacto' },
  ];

  const legalLinks = [
    { label: 'Términos y Condiciones', href: '/terminos-y-condiciones' },
    { label: 'Política de Privacidad', href: '/politica-de-privacidad' },
    { label: 'Libro de Reclamaciones', href: '/libro-de-reclamaciones' },
  ];

  return (
    <footer className="bg-primary-900 relative overflow-hidden">
      {/* Decorative */}
      <div className="absolute top-0 left-1/4 w-64 h-64 bg-primary-800/50 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-48 h-48 bg-secondary-800/30 rounded-full blur-3xl" />

      {/* Main Footer */}
      <div className="relative z-10 px-4 md:px-6 lg:px-10 xl:px-16 py-14 md:py-18">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <img
                src="https://storage.helloreaddy.io/project_files/4cfcb1de-7be5-4e62-8f0e-710035700b11/c801fb1e-2e16-4012-abaa-69f33fbdb05f_compressed_Logo-Suvi-Digital.webp"
                alt="Suvi Digital"
                className="h-8 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-white/60 text-sm leading-relaxed mb-5">
              Agencia de marketing digital y e-commerce especializada en agencias de viaje y tour operadores.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://www.linkedin.com/in/hernansuclla/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-xl bg-white/10 hover:bg-accent-500 hover:text-white text-white/70 transition-all"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-sm" />
              </a>
              <a
                href="https://wa.me/51989307864"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-xl bg-white/10 hover:bg-accent-500 hover:text-white text-white/70 transition-all"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-sm" />
              </a>
              <a
                href="mailto:hernan@suvidigital.com"
                className="w-9 h-9 flex items-center justify-center rounded-xl bg-white/10 hover:bg-accent-500 hover:text-white text-white/70 transition-all"
                aria-label="Email"
              >
                <i className="ri-mail-line text-sm" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-semibold text-base text-white mb-4">Servicios</h4>
            <ul className="space-y-2.5">
              {serviceLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-white/50 hover:text-accent-400 text-sm transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading font-semibold text-base text-white mb-4">Empresa</h4>
            <ul className="space-y-2.5">
              {companyLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-white/50 hover:text-accent-400 text-sm transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal + Contact */}
          <div>
            <h4 className="font-heading font-semibold text-base text-white mb-4">Legal</h4>
            <ul className="space-y-2.5 mb-6">
              {legalLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-white/50 hover:text-accent-400 text-sm transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <h4 className="font-heading font-semibold text-base text-white mb-3">Contacto</h4>
            <p className="text-white/50 text-sm">hernan@suvidigital.com</p>
            <p className="text-white/50 text-sm">+51 989 307 864</p>
            <p className="text-white/50 text-sm">Lima, Perú</p>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="relative z-10 border-t border-white/10 px-4 md:px-6 lg:px-10 xl:px-16 py-5">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs">
            &copy; {currentYear} Suvi Digital. Todos los derechos reservados.
          </p>
          <p className="text-white/40 text-xs flex items-center gap-1">
            Hecho con <i className="ri-heart-fill text-accent-500 text-xs" /> en Perú
          </p>
        </div>
      </div>
    </footer>
  );
}